// extracted by mini-css-extract-plugin
export default {"link":"link--SpIBs","icon":"icon--RP4OY"};